// import { useEffect, useState } from 'react';
// import { fetchPieces, fetchPieceReferrals, fetchReviewsView } from '../services/api';
import { useEffect, useMemo, useState } from 'react';
import Header from '../components/Header';
import { fetchCompetitions, fetchCompetitionById } from '../services/api';
import CompEntriesbyCountryChart from '../components/CompEntriesbyCountryChart';
import CompEntriesbyRefChart from '../components/CompEntriesbyRefChart';
import SubmittedPiecesChart from '../components/SubmittedPiecesChart';
import CompEntriesbyAge from '../components/CompEntriesbyAge';
import SubmittedPiecesTotal from '../components/SubmittedPiecesTotal';
import VisitorsByCountryMap from '../components/VisitorsByCountryMap';
import VisitorsByPageChart from '../components/VisitorsByPageChart';

const Competition = () => {
  const [isInIframe, setIsInIframe] = useState(false);
  const [competitions, setCompetitions] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const selectedCompetition = useMemo(
    () => competitions.find(c => c.competition_id === selectedId) || null,
    [competitions, selectedId]
  );
  const startDate = useMemo(() => selectedCompetition?.started_at, [selectedCompetition]);
  const promptId = useMemo(() => Number(selectedCompetition?.wtw_prompt_id), [selectedCompetition]);
  const competitionName = useMemo(() => selectedCompetition?.competition_name, [selectedCompetition]);
  const competitionId = useMemo(() => selectedCompetition?.competition_id, [selectedCompetition]);
  useEffect(() => {
    // Check if running in iframe
    const checkIframe = () => {
      try {
        setIsInIframe(window.self !== window.top);
      } catch (e) {
        // If we can't access window.top, we're likely in an iframe
        setIsInIframe(true);
      }
    };

    checkIframe();
  }, []);

  useEffect(() => {
    // If a competitionId is present in the URL, fetch by id; else load list
    const params = new URLSearchParams(window.location.search);
    const idParam = params.get('competitionId');
    const competitionIdFromUrl = idParam ? Number(idParam) : null;

    const load = async () => {
      if (competitionIdFromUrl) {
        const record = await fetchCompetitionById(competitionIdFromUrl);
        const list = Array.isArray(record) ? record : [];
        if (list.length > 0) {
          setCompetitions(list);
          setSelectedId(list[0].competition_id);
          return;
        }
      }
      const data = await fetchCompetitions();
      setCompetitions(data);
      setSelectedId(data?.[0]?.competition_id ?? null);
    };
    load();
  }, []);

  // Removed postMessage path now that competitionId is provided via iframe src

  if (!selectedCompetition || !selectedId || competitions.length === 0) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg text-gray-600">Loading Competition...</div>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "sans-serif" }}>
      {/* Header - only show when not in iframe */ }
      {!isInIframe && <Header pageTitle={`${competitionName} Competition Breakdowns`} />} 
      
      <div style={{ padding: isInIframe ? "20px" : "40px" }}>

      {/* Selector */}
      {!isInIframe && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          <label htmlFor="competitionSelect" style={{ fontWeight: 600 }}>Competition:</label>
          <select
            id="competitionSelect"
            value={selectedId ?? ''}
            onChange={(e) => setSelectedId(Number(e.target.value))}
            style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #ccc' }}
          >
            {competitions.map((c) => (
              <option key={c.competition_id} value={c.competition_id}>
                {c.competition_name} ({c.started_at})
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Metrics Row */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        gap: "40px",
        marginBottom: "40px"
      }}>
        <SubmittedPiecesTotal startDate={startDate} promptId={promptId} />
      </div>

      {/* Row 1: Country + Referral Source Pie Charts */}
      <div style={{
        display: "grid",
        gridTemplateColumns: isInIframe ? "1fr" : "1fr 1fr",
        gap: "40px",
        marginBottom: "60px"
      }}>
        <div>
          <h2>Competition Entries by User's Country</h2>
          <CompEntriesbyCountryChart startDate={startDate} promptId={promptId} />
        </div>
        <div>
          <h2>Competition Entries by User's Referral Source</h2>
          <CompEntriesbyRefChart startDate={startDate} promptId={promptId} />
        </div>
      </div>

      {/* Row 2: Line Chart + Age Distribution Pie */}
      <div style={{
        display: "grid",
        gridTemplateColumns: isInIframe ? "1fr" : "1fr 1fr",
        gap: "40px",
        marginBottom: "60px"
      }}>
        <div>
          <h2># of Submitted Pieces</h2>
          <SubmittedPiecesChart startDate={startDate} promptId={promptId} />
        </div>
        <div>
          <h2>Competition Entries by Age</h2>
          <CompEntriesbyAge startDate={startDate} promptId={promptId} />
        </div>
      </div>

      {/* Row 3 */}
      <div style={{
        display: "grid",
        gridTemplateColumns: isInIframe ? "1fr" : "1fr 1fr",
        gap: "40px"
      }}>
        <div>
          <h2>Visitors by Country</h2>
          <VisitorsByCountryMap startDate={startDate} />
        </div>
        <div>
          <h2>Visitors by Page</h2>
          <VisitorsByPageChart startDate={startDate} promptId={promptId} competitionId={competitionId} />
        </div>
      </div>
      </div>
    </div>
  );
};

export default Competition;
